import { BAYS } from '../../../../../../../constants';

import type { IRecommendation, Bays } from '../../../../../../../utils/types';

export function showProvisionDescriptionField(showProvisionDescription: boolean, tpBay: Bays) {
  return showProvisionDescription && tpBay !== BAYS.BAY_2_5;
}

export function shouldShowTherapyProvisioningDescription(
  recommendation: IRecommendation | null | undefined,
): boolean {
  return !recommendation?.considered_factors;
}
